<div class="navbar-header">
    <a [href]="logoLinkUrl" class="navbar-brand" [target]="targetBlank ? '_blank' : '_self'">
        <img src="./assets/img/sendpulse-logo-menu.svg" [width]="logoWidth" [height]="logoHeight" alt="SendPulse" />
    </a>
</div>
